// @ts-check
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { getClient } from '../redux/actions/client-actions';

import { makeStyles } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import { Paper, Typography } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import { LoadingComponent } from '../components/loading-component';
import { UploadLogoComponent } from '../components/upload-logo-component';
import { SuperUserComponent } from '../components/super-user-component';
import { ClientComponent } from '../components/client-component';
import { ApiKeyComponent } from '../components/api-key-component';
import { ClientTypeComponent } from '../components/client-type-component';
import { GeneralPermissionsComponent } from '../components/general-permissions-component';
import { ContractsPage } from '../../../contracts/presentation/pages/contracts-page';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import { ClientInfoComponent } from '../components/client-info-component';
import { generateTimezoneDisplay } from '../../../../core/utils/timezone-utils';
import { generateCurrencyDisplay } from '../../../../core/utils/currency-utils';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  sectionHeading: {
    margin: theme.spacing(3)
  },
  clientHeader: {
    textAlign: 'center'
  },
  clientLogo: {
    height: '10rem',
    width: '10rem',
    objectFit: 'contain'
  },
  large: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  }
}));

function Client({ client }) {
  const classes = useStyles();
  return (
    <Paper className={classes.paper} elevation={0}>
      <UploadLogoComponent client={client} />
    </Paper>
  );
}

function CenteredGrid({ client }) {
  const timezone = generateTimezoneDisplay(client.timezone);
  const currency = generateCurrencyDisplay(client.currency);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Client client={client} />
      </Grid>

      <Grid item xs={12} md={8}>
        <ClientComponent client={client} />
        <SuperUserComponent client={client} />
        <ClientTypeComponent client={client} />
        {client.plan && (
          <ClientInfoComponent headingText={'Client Plan'} displayValue={client.plan} />
        )}
        <ApiKeyComponent client={client} />
        <ClientInfoComponent headingText={'Timezone'} displayValue={timezone} />
        {client.currency && (
          <ClientInfoComponent headingText={'Currency'} displayValue={currency} />
        )}
        <GeneralPermissionsComponent client={client} />
        <ContractsPage client={client} />
      </Grid>
    </Grid>
  );
}

export default function ClientPage() {
  // @ts-ignore
  const { id } = useParams();
  const classes = useStyles();

  const { client, loading, success } = useSelector((state) => state.client);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClient(id));
  }, [dispatch, id]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && success && (
            <>
              <BackNavigationComponent
                page="Client"
                uri="/clients"
                path={[
                  {
                    page: 'Home',
                    uri: '/'
                  },
                  {
                    page: 'Clients',
                    uri: '/clients'
                  }
                ]}
              />
              <CenteredGrid client={client} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
